<template>
  <e-dialog
      dialogTitle="反馈进度"
      :centerDialogVisible="visible"
      buttonTip="提 交"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      :popupWidth="'580px'">
    <el-form v-if="visible" :rules="rules" :model="form" label-width="80px" ref="form">
      <el-form-item label="反馈内容：" prop="feedbackContent">
        <el-input v-model="form.feedbackContent" placeholder="请输入"
                  type="textarea" :maxlength="100" show-word-limit :rows="2">
        </el-input>
      </el-form-item>
    </el-form>
    <e-table-list
        maxHeight="400"
        :loading="tableLoading"
        :table-data="tableData"
        :table-label="tableLabel">
    </e-table-list>
  </e-dialog>
</template>

<script>
  import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
  import eTableList from '@/modules/projectA/components/common/e-table-list';
  import Api from '@/modules/projectA/api/ESorganization';

  export default {
    name: 'feedbackDialog',
    components: { eDialog, eTableList },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      //反显数据
      details: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        tableLoading: false,
        tableData: [],
        tableLabel: [
          {
            label: '反馈人',
            param: 'feedbackName',
            align: 'center',
            minWidth: 110
          },
          {
            label: '反馈时间',
            param: 'feedbackTime',
            align: 'center',
            minWidth: 140
          },
          {
            label: '反馈内容',
            param: 'feedbackContent',
            align: 'center',
            minWidth: 110,
            tooltip: true
          }
        ],
        form: {
          feedbackContent: ''
        },
        rules: {
          feedbackContent: [{ required: true, message: '请输入' }]
        }
      };
    },
    methods: {
      getList() {
        this.tableLoading = true;
        Api.queryApplyAgencyFeedbackList({
          applyId: this.details.applyId,
          applyItemPriceId: this.details.applyItemPriceId
        }).then(res => {
          if (res.code === '200') {
            this.tableData = res.data;
          }
        });
        this.tableLoading = false;
      },
      resetPopupData() {
        this.$emit('update:visible', false);
      },
      submitPopupData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Api.addApplyAgencyFeedbackInfo({
              applyId: this.details.applyId,
              applyItemPriceId: this.details.applyItemPriceId,
              ...this.form
            }).then(res => {
              if (res.code === '200') {
                this.$message.success('操作成功');
                this.resetPopupData();
              }
            });
          }
        });
      }
    },
    watch: {
      visible: {
        handler(newVal) {
          if (newVal) {
            this.getList();
          } else {
            this.form = {
              feedbackContent: ''
            };
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    textarea {
      resize: none !important;
      height: 60px;
      padding: 6px 10px;
      border-radius: 0;
    }

    .el-form-item__label {
      padding-right: 0;
    }
  }

</style>
